export default __webpack_public_path__ + "static/media/3.207bd8a2.png";